import { MeasurementUnitCode } from "../utils/enums"

type Moment = moment.Moment


export type QuestionType = 'checkbox' | 'rating' | 'open';
export type QuestionResponseType = string | string[] | { [key: string]: number } | boolean


export interface FocusGroupSessionResponseSchema {
  [key: string]: QuestionResponseType
}


export interface QuestionSchema {
  id: string;
  type: QuestionType;
  title: string;
  text: string;
  options?: string[];
  maxSelections?: number;
}

export interface SectionSchema {
  id: string;
  title: string;
  icon: any;
  questions: QuestionSchema[];
}

// export interface SessionSchema {
//   id: string;
//   title: string;
//   sections: SectionSchema[];
// }

export interface FocusGroupSessionSchema {
  id: string;
  community_id: string;
  orgName: string;
  orgLogo: string;
  sessionNumber: number;
  sessionDate: Moment;
  sessionType: 'focus_group' | 'training' | 'survey' | 'workshop' | 'consultation' | 'event' | 'other';
  allowAnonymous: boolean;
  duration: number;
  title: string;
  description: string;
  sections: SectionSchema[]
  resource_id?: string;
  resource_type?: ResourceType;
}

export type BusinessStageType = 'dream' | 'build' | 'scale';

export type TabValuesByStage = {
  dream: 'business' | 'focus-group';
  build: 'recommendations' | 'focus-group';
  scale: 'menu' | 'focus-group';
}

export type BusinessTabType = {
  [K in BusinessStageType]: TabValuesByStage[K]
}


export type Step = {
  id: number;
  name: string;
  isCompleted: boolean;
};

export type BusinessFormData = {
  businessName: string;
  businessCategory: number;
  businessType: string;
  yearsOfOperation: string;
  description: string;
  businessStage: BusinessStageType;
  // Kitchen preferences
  cookingState: string;
  cookingCounty: string;
  otherLocation?: string;
  kitchenTimeframe: string;
  kitchenBudget: string;
  kitchenFrequency: string;
  kitchenSize: string;
  kitchenEquipment: string[];
  kitchenFeatures: string[];
  maxChefs: string;
  paymentFrequency: string;
  kitchenType: string;
};


export type MyBusinessSchema = {
  id?: string;
  username: string;
  community_ids?: string[];
  business_name: string;
  business_category: string;
  business_type: string;
  years_of_operation: string;
  description: string;
  business_stage: BusinessStageType;
  cooking_state: string;
  cooking_county: string;
  other_location?: string;
  kitchen_timeframe: string;
  kitchen_budget: string;
  kitchen_frequency: string;
  kitchen_size: string;
  kitchen_equipment: string[];
  kitchen_features: string[];
  max_chefs: string;
  payment_frequency: string;
  kitchen_type: string;
};

export type SortByType = 'name' | 'state' | 'rating' | 'zipcode' | 'created' | 'active' | 'county'

export interface AccountSchema {
  id?: string
  uid?: string
  first_name?: string,
  last_name?: string,
  avatar?: string
  phone?: string
  email?: string
  provider_id?: string
  token_username?: string | undefined
  username?: string
  auth_status?: boolean
  login_token?: string
  refresh_token?: string
  appstage?: string
  _sch_email?: string
  created?: string
  login_community?: CommunitySchema
  primary_community?: string
  member_community?: string
  accessToken?: string
  saved_resources?: SavedResourceSchema[]
  address?: string
  city?: string
  state?: string
  zipcode?: string
  payment_method?: string
  cart_items?: OrderItemSchema[]
}

export type PaymentStatusType = "succeeded" | "requires_confirmation" | "failed" | "canceled"

export interface PaymentHistoryItemSchema extends Omit<ResourceBookingSchema, 'status'> {
  id: string;
  email: string;
  // resourceName: string;
  amount: number;
  payment_method: any;
  customer: string;
  cardNumber: string;
  transactionId: string;
  date: string;
  status: PaymentStatusType;
}

export interface FilterOptionSchema {
  category: string
  items: string[]
}

export interface TimeBlock {
  start: Moment;
  end: Moment;
} 

export interface TrainingSchema {
  date: string
  times: string[]
  duration: number
}

export interface TrainingOrganizationSchema {
[key: string]: TrainingSchema[]
}

export interface ResourceInventorySchema {
  [key: string]: InventorySchema[]
  }


export interface FilterOptionSchema {
  category: string
  items: string[]
}

export type EnvironmentOptions = 'dev' | 'test' | 'prod'

export type AuthSchema = {
  phone?: string | undefined
  email?: string
  token_uid?: string
  web_env?: EnvironmentOptions
  last_page_path?: string
}

// -----------------------------------------------------------------------------
//  Firebase Identity Provider (IDP) user object type definitions
// -----------------------------------------------------------------------------

// export interface IdpProviderData {
//   providerId: string
//   uid: string
//   displayName?: string | null
//   email?: string | null
//   phoneNumber?: string | null
//   photoURL?: string | null
// }

// export interface StsTokenManager {
//   refreshToken: string
//   accessToken: string
//   expirationTime: number
// }

export interface IdpAccountRequestSchema {
  uid: string
  email?: string | null
  emailVerified: boolean
  displayName?: string | null
  isAnonymous: boolean
  photoURL?: string | null
  providerId: string
  // providerData: IdpProviderData[]
  // stsTokenManager: StsTokenManager
  createdAt: string
  // lastLoginAt: string
  // apiKey: string
  // appName: string
}

export type AuthContextType = {
  value?: string
  authUser?: AccountSchema
  isloggedin?: boolean, 
  isverified?: boolean, 
  loginType?: string, 
  currentPreferences?: PreferenceSchema
  handleUpdateLoginType?: ((loginType: string) => void), 
  updateProfile?: (user_data: AccountSchema) => boolean, 
  verifyUser?: (otp: string) => boolean, 
  registerUser?: (user: AuthSchema) => boolean, 
  loadAuthUser?: () => boolean, 
  signOutUser?: () => void
}

export type AuthStateType = {
  // value?: any;
  communityId?: string
  userData?: AccountSchema;
  primaryCommunity?: CommunitySchema
  isloggedin?: boolean;
  isverified?: boolean;
  loginType?: string;
  currentPreferences?: PreferenceSchema
  cartItems?: OrderItemSchema[]
  updateCartItems?: React.Dispatch<React.SetStateAction<OrderItemSchema[]>>
  updateUserData?: React.Dispatch<React.SetStateAction<AccountSchema>>
  updateLogin?: React.Dispatch<React.SetStateAction<boolean>>
  updateVerified?: React.Dispatch<React.SetStateAction<boolean>>
  updatePrimaryCommunity?: React.Dispatch<React.SetStateAction<CommunitySchema>>
}
export type MembershipStateType = {
  // communityId: string
  memberships: MembershipSchema[]
  setMemberships: React.Dispatch<React.SetStateAction<MembershipSchema[]>>
  membershipRequests: MembershipSchema[]
  setMembershipRequests: React.Dispatch<React.SetStateAction<MembershipSchema[]>>
  bookings: BookingSchema[]
  updateBookings: React.Dispatch<React.SetStateAction<BookingSchema[]>>
  currentBooking: BookingSchema | null
  updateCurrentBooking: React.Dispatch<React.SetStateAction<BookingSchema | null>>
  currentMember: MembershipSchema | null
  updateCurrentMember: React.Dispatch<React.SetStateAction<MembershipSchema | null>>

  currentChatCommunity: string
  changeChatCommunity: React.Dispatch<React.SetStateAction<string>>
  newMessageMember: string
  changeNewMessageMember: React.Dispatch<React.SetStateAction<string>>

  allMessages: MessageSchema[]
  updateAllMessages: React.Dispatch<React.SetStateAction<MessageSchema[]>>
  messageThread: MessageSchema[]
  updateMessageThread: React.Dispatch<React.SetStateAction<MessageSchema[]>>
  allThreadsByCommunity: GroupedMessageListType
  updateAllsThreadsByCommunity: React.Dispatch<React.SetStateAction<GroupedMessageListType>>
}

export type MessageContextType = {
  
  updateCurrentBooking?: (user: AccountSchema) => boolean, 
  getMemberBookings?: () => boolean, 
  getBookingByID?: (communityId: string, bookingId: string) => void
  addNewBooking?: (newBooking: BookingSchema) => void
}


export type MessageStateType = {
  // communityId: string

  currentChatCommunity: 'chatbot' | 'staff'
  changeChatCommunity: React.Dispatch<React.SetStateAction<'chatbot' | 'staff'>>
  newMessageMember: string
  changeNewMessageMember: React.Dispatch<React.SetStateAction<string>>

  allMessages: MessageSchema[]
  updateAllMessages: React.Dispatch<React.SetStateAction<MessageSchema[]>>
  messageThread: MessageSchema[]
  updateMessageThread: React.Dispatch<React.SetStateAction<MessageSchema[]>>
  allThreadsByCommunity: GroupedMessageListType
  updateAllsThreadsByCommunity: React.Dispatch<React.SetStateAction<GroupedMessageListType>>
}

export type MemberContextType = {
  value?: string
  memberships?: AccountSchema
  bookings?: BookingSchema[], 
  currentBooking?: BookingSchema, 
  loginType?: string, 
  getAccountMembership?: ((communityId: string, accountId: string) => MembershipSchema) | undefined, 
  getMemberships?: (user_data: AccountSchema) => boolean, 
  // addKitchenMember?: (otp: string) => boolean, 
  addKitchenMember?: (communityId: string, membership: MembershipSchema) => boolean
  updateCurrentBooking?: (user: AccountSchema) => boolean, 
  getMemberBookings?: () => boolean, 
  getBookingByID?: (communityId: string, bookingId: string) => void
  addNewBooking?: (newBooking: BookingSchema) => void
}


export type ResourceStateType = { 
  idSort?: boolean
  nameSort?: boolean
  allResources?: ResourceSchema[]
  currentResource?: ResourceSchema
  searchQuery?: string
  globalFilter: FilterType
  setGlobalFilter?: React.Dispatch<React.SetStateAction<FilterType>>
  clearCurrentResource?: () => void
  updateResources?: React.Dispatch<React.SetStateAction<ResourceSchema[]>>
  updateCurrentResource?: React.Dispatch<React.SetStateAction<ResourceSchema>>
  handleSearch?: (value: string) => void
  toggleNameSort?: () => void
  toggleIDSort?: () => void
}

export type CommunityStateType = { 
  // communityId?: string
  allCommunities?: CommunitySchema[]
  currentCommunity?: CommunitySchema
  allKitchens?: KitchenSpaceSchema[];
  currentKitchen?: KitchenSpaceSchema;
  plans?: PlanSchema[]
  requirements?: RequirementSchema[]
  searchQuery?: string
  idSort?: boolean
  nameSort?: boolean
  setKitchen?: React.Dispatch<React.SetStateAction<KitchenSpaceSchema | null>>
  updateCommunities?: React.Dispatch<React.SetStateAction<CommunitySchema[]>>
  updateCurrentCommunity?: React.Dispatch<React.SetStateAction<CommunitySchema | null>>
  updateKitchens?: React.Dispatch<React.SetStateAction<KitchenSpaceSchema[]>>
  setPlans?: React.Dispatch<React.SetStateAction<PlanSchema[]>>
  setRequirements?: React.Dispatch<React.SetStateAction<RequirementSchema[]>>
  handleSearch?: (value: string) => CommunitySchema[];
  toggleNameSort?: () => void;
  toggleIDSort?: () => void;
  clearCurrentKitchen?: () => void;
}


export interface InventorySchema {
  id?: string
  community_id?: string
  item_name: string
  item_description?: string
  image_url?: string
  unit_price?: number
  category: string
  total_quantity: number
  available_quantity?: number
  measure_unit?: MeasurementUnitCode
  resource_id?: string
  resource_type: ResourceType
  is_reusable?: boolean
  condition?: "new" | "working" | "damaged" | "lost" | "stolen" | "refurbished" | "under_repair" | "broken" | "expired" | "disposed"
}


export interface OrderItemSchema extends InventorySchema {
  id: string
  inventory_id: string
  fees?: number
  timestamp?: string
  resource_name?: string
}


export type CommunityContextType = {
  value?: string
  allCommunities?: CommunitySchema[]
  allKitchens?: KitchenSpaceSchema[]
  currentCommunity?: CommunitySchema, 
  messageList?: MessageSchema[], 
  currentPlans?: PlanSchema[]
  loadAllCommunities?: (() => boolean) | undefined, 
  getCommunity?: (id: string) => CommunitySchema | null, 
  searchAllCommunities?: (q: string) => boolean, 
  updateMessageList?: (messageList: MessageSchema[]) => void, 
  getAIMessage?: (prompt: string) => MessageSchema | null
  updateCurrentPlans?: React.Dispatch<React.SetStateAction<PlanSchema[]>>
}


export interface ConnectionProp {
  connection: AccountSchema
}
export type UserListProps = {
  messages_by_recipient?: {[key: string]: MessageSchema[]},
  currentUser?: any,
  changeUser?: (currentUser:string | null) => void
}

export type EquipmentsWidgetProps = {
  selectedEquipments?: string[] | undefined, 
  updateSelectedEquipments: (all_equipments: string[]) => void,
}

export type CreateBookingProps = {
  // selectedEquipments?: string[], 
  // updateSelectedEquipments: (all_equipments: string[]) => void,
  resourceDetail: ResourceSchema
  toggleBookingRequest: (isBookingRequest: boolean) => void,
  handleBooking: (option: string) => void,
}


export type CommunityListSchema = {
  count: number
  communities: CommunitySchema[]
}

export type ExpandedMembershipSchema = {
  isExpanded: boolean;
  requirementsStatus: CurrentRequirementsSchema[];
  totalRequirementsCount: number;
  metRequirementsCount: number;
}

export type AddRequirementStatus = { status: boolean, requirement?: CurrentRequirementsSchema }

export type CredentialExpirationStatus = 'none' | 'valid' | 'expiring_soon' | 'expired';

export type CredentialExpirationInfo = {
  status: CredentialExpirationStatus;
  formattedDate: string | null;
  daysUntilExpiration: number | null;
  statusLabel: string | null;
  detailLabel: string | null;
};

export interface CurrentRequirementsSchema extends RequirementSchema {
  // title: string
  // id?: string
  // description: string
  // code: string;
  // name: string;
  is_met: boolean
  is_required: boolean
  presigned_url?: string
  expiration: string
  credential_number: string
  municipality: string
}

export interface MessageSchema {
  id?: string
  community_id: string
  subject?: string
  read_status?: boolean,
  type?: 'sent' | 'received',
  content: string,
  username: string
  created: string
  last_updated?: string
}

export interface GroupedMessageListType {
  [key: string]: MessageSchema[]
}

export interface  RequirementSchema {
  name: string,
  description?: string,
  code: string,
  community_id?: string,
  resource_id?: string,
  created?: string,
  category?: string | 
    'orientation_training' | 
    'orientation_workshop' | 
    'orientation_webinar' | 
    'orientation_seminar' | 
    'orientation_course' | 
    'orientation_event' | 
    'orientation_resource' | 
    'orientation_tool' | 
    'orientation_guide' | 
    'orientation_manual' | 
    'orientation_video' | 
    'orientation_audio' | 
    'orientation_document' | 
    'orientation_presentation' | 
    'orientation_report' | 
    'orientation_study' | 
    'orientation_research' | 
    'orientation_analysis' | 
    'orientation_evaluation' | 
    'orientation_feedback' | 
    'orientation_suggestion' | 
    'orientation_improvement' | 
    'orientation_recommendation' | 
    'orientation_guidance' | 
    'orientation_instruction',
  validity?: string,
  id?: string
}

export type ResourceType = 'kitchen' | 'documentation' | 'training' | 'funding' | 'expert' | 'farm'

/** Optional context when opening an apply/booking modal from inventory. */
export type ToggleApplyModalOptions = {
  inventoryItem?: InventorySchema;
};
export type BookingStatusType = 'pending' | 'approved' | 'canceled' | 'in_progress' | 'completed'
export type BookingViewMode = 'grid' | 'list' | 'calendar'
export type BookingSortField =
  | 'start_time'
  | 'resource_name'
  | 'resource_type'
  | 'status'
  | 'total_hours'
  | 'plan_rate'
  | 'total_cost'
  | 'created'
export type BookingSortDirection = 'asc' | 'desc'

export interface BookingFilterState {
  statuses: BookingStatusType[]
  resourceTypes: ResourceType[]
  resourceName: string
  dateFrom: string
  dateTo: string
  planRateMin: string
  planRateMax: string
  totalCostMin: string
  totalCostMax: string
  durationMin: string
  durationMax: string
}

export const defaultBookingFilterState: BookingFilterState = {
  statuses: [],
  resourceTypes: [],
  resourceName: '',
  dateFrom: '',
  dateTo: '',
  planRateMin: '',
  planRateMax: '',
  totalCostMin: '',
  totalCostMax: '',
  durationMin: '',
  durationMax: '',
}

export type PlanRecurrenceOptions = 'hourly' | 'daily' | 'weekly' | 'monthly' | 'annual'
export type BookingRecurrenceType = 'once' | PlanRecurrenceOptions
/** Billable subscription cadences (excludes hourly/daily booking rates) */
export type SubscriptionRecurrenceType = Exclude<PlanRecurrenceOptions, 'hourly' | 'daily'>
export type MembershipStatusType = 'pending' | 'declined' | 'approved' | 'verified' | 'active' | 'inactive' | 'removed'
/** Lifecycle status for a recurring subscription plan */
export type SubscriptionStatusType =
  | 'active'
  | 'past_due'
  | 'canceled'
  | 'inactive'
  | 'pending'
  | 'trialing'

/** resourceId → active booking planId for that resource */
export type MemberResourceBookingPlanIdsMap = Record<string, string>

/** resourceId → remaining booking balance (hours) for that resource */
export type MemberResourceBookingBalanceMap = Record<string, number>

/**
 * Persistable JSON string of `MemberResourceBookingPlanIdsMap`.
 * Runtime example: `'{"resource-1":"plan-1","resource-2":"plan-2"}'`
 * Always keep in sync via stringify/parse helpers — never invent ad-hoc shapes.
 */
export type MemberResourceBookingPlanIdsJsonString = string & {
  readonly __brand?: 'MemberResourceBookingPlanIdsJsonString'
}

/**
 * Persistable JSON string of `MemberResourceBookingBalanceMap`.
 * Runtime example: `'{"resource-1":10,"resource-2":5}'`
 * Always keep in sync via stringify/parse helpers — never invent ad-hoc shapes.
 */
export type MemberResourceBookingBalanceJsonString = string & {
  readonly __brand?: 'MemberResourceBookingBalanceJsonString'
}

/** Empty JSON object string for booking plan id maps */
export const EMPTY_MEMBER_BOOKING_PLAN_IDS_JSON =
  '{}' as MemberResourceBookingPlanIdsJsonString

/** Empty JSON object string for booking balance maps */
export const EMPTY_MEMBER_BOOKING_BALANCES_JSON =
  '{}' as MemberResourceBookingBalanceJsonString

/** inventoryId → remaining included qty for that inventory item */
export type MemberInventoryLimitsMap = Record<string, number>

/**
 * Persistable JSON string of `MemberInventoryLimitsMap`.
 * Runtime example: `'{"inventory-1":3,"inventory-2":1}'`
 * Seeded from dual plan `associated_resources[].inventory.max_qty`.
 */
export type MemberInventoryLimitsJsonString = string & {
  readonly __brand?: 'MemberInventoryLimitsJsonString'
}

/** Empty JSON object string for inventory limits maps */
export const EMPTY_MEMBER_INVENTORY_LIMITS_JSON =
  '{}' as MemberInventoryLimitsJsonString

export interface MembershipSchema extends CommunitySchema {
  uid?: string
  id?: string
  avatar?: string
  last_updated?: string;
  is_admin?: boolean;
  license_verified?: boolean;
  phone_verified?: boolean;
  resource_id?: string;
  restrictions?: string;
  member_balance?: number;
  status?: MembershipStatusType
  payment_method?: string;
  plan_id?: string;
  plan_rate?: number;
  plan_name?: string;
  plan_max_hours?: number;
  plan_recurrence?: BookingRecurrenceType
  plan_description?: string;
  /**
   * JSON-stringified `MemberResourceBookingPlanIdsMap` (`Record<resourceId, planId>`).
   * Prefer `plan_id` when the membership is scoped to a single resource.
   */
  booking_plan_ids?: MemberResourceBookingPlanIdsJsonString
  /**
   * JSON-stringified `MemberResourceBookingBalanceMap` (`Record<resourceId, number>`).
   * Prefer `member_balance` when the membership is scoped to a single resource.
   */
  booking_balances?: MemberResourceBookingBalanceJsonString
  /**
   * JSON-stringified map of inventory_id → remaining included qty.
   * Seeded from dual plan associated_resources[].inventory max_qty.
   */
  inventory_limits?: MemberInventoryLimitsJsonString
  // resource_plan_ids?: string[]
  community_approved?: boolean;
  email_verified?: boolean;
  community_id?: string;
  joined?: string;
  manually_approve?: boolean;
  background_verified?: boolean;
  username?: string;
  phone?: string;
  email?: string;
  state?: string
  first_name?: string
  last_name?: string
  team_name?: string
  zipcode?: string
  member_agreement?: AgreementSubmissionSchema
  team_members?: TeamMemberSchema[]
}

/**
 * Account subscription for non-hourly / non-daily plan cadences (weekly, monthly, annual).
 * Focused on plan identity, linked resources/types, and renewal / next-charge timing for Profile subscriptions UI.
 */
export interface SubscriptionSchema {
  id?: string
  uid?: string
  username?: string
  community_id?: string
  /** Community or product display name */
  name?: string
  logo?: string
  description?: string
  resource_id?: string
  resource_name?: string
  resource_type?: ResourceType
  status?: SubscriptionStatusType
  plan_id?: string
  plan_name?: string
  plan_description?: string
  plan_rate?: number
  /** Must be weekly | monthly | annual (not hourly/daily) */
  plan_recurrence?: SubscriptionRecurrenceType
  plan_max_hours?: number
  plan_type?: PlanType
  is_fulltime_hours?: boolean
  /** Linked resources included with the subscription plan */
  associated_resources?: PlanResourceAssociation[]
  /** ISO date/time of the next renewal / charge */
  next_charge_date?: string
  /** ISO date/time when the current billing period ends */
  current_period_end?: string
  /** ISO date/time of the last successful charge */
  last_charge_date?: string
  /** ISO date/time when the subscription started */
  started?: string
  last_updated?: string
  payment_method?: string
  /** When true, subscription will not renew after current_period_end */
  cancel_at_period_end?: boolean
}

export type AgreementSignatoryInfo = {
  registeredBusinessName: string;
  registeredBusinessEntity: string;
  adminSignatoryName: string;
  adminSignatoryJobTitle: string;
  selectedResourceIds?: string[];
};

/** Community (member) agreement from API; url is presigned S3 URL for the .docx file. */
export interface CommunityAgreementSchema {
  id?: string;
  community_id?: string;
  name?: string;
  description?: string;
  resource_id?: string;
  url: string;
  file_key?: string;
  content?: string;
  last_updated?: string;
  created?: string;
  signatory_info?: AgreementSignatoryInfo;
  security_deposit: number;
}

/** Member/guarantor info used to fill agreement placeholders in the preview. */
export type AgreementMemberInfo = {
  fullName?: string;
  companyName?: string;
  date?: string;
  titlePosition?: string;
  address?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  phone?: string;
  ownerDriversLicense?: string;
  ownerSSN?: string;
  memberFEIN?: string;
  memberInsurance?: string;
  foodSafetyCertDate?: string;
  /** Data URL of drawn signature image (e.g. from canvas.toDataURL('image/png')). */
  signatureDataUrl?: string;
};

export interface AgreementSubmissionSchema extends AgreementMemberInfo {
  id?: string;
  agreement_source_id?: string;
  community_id?: string;
  username?: string;
  file_url?: string;
  file_key?: string;
  content?: string;
  submitted?: string;
  // signatory_info?: AgreementSignatoryInfo;
  signature_data_url?: string;
  security_deposit?: number;
}

export interface ReviewSchema {
  "reviewer_phone"?: string
  "comment": string
  "timestamp": string
  "reviewer_community_name": string
  "reviewer_community_id": string
  "reviewer_name"?: string
  "reviewer_email"?: string
  "experience_rating": number
  "cleanliness_rating"?: number
  "organization_rating"?: number
  "username": string
  "avatar": string
}

export interface PlanInventorySelection {
  inventory_id: string
  max_qty: number
}

export interface PlanResourceAssociation {
  resource_id: string
  resource_name?: string
  max_duration: number
  inventory?: PlanInventorySelection[]
}

export interface PlanSchema  {
  category?: string
  community_id?: string
  plan_id?: string
  plan_description?: string
  plan_name?: string
  plan_rate?: number
  plan_recurrence?: PlanRecurrenceOptions
  plan_max_hours?: number
  pricing_type?: PricingType
  features?: string[]
  plan_type?: PlanType
  is_fulltime_hours?: boolean
  associated_resources?: PlanResourceAssociation[]
}

export type PricingType = 'fixed' | 'dynamic'
export type PlanType = 'membership' | 'resource' | 'dual'
export type PeriodType = 'STANDARD' | 'PEAK' | 'OFF_PEAK'

export interface ResourcePlanSchema extends PlanSchema {
  plan_type: PlanType
  resource_id?: string
  resource_type?: ResourceType
  overage_rate?: number
  peak_rate?: number
  off_peak_rate?: number
}


export interface CredentialSchema {
  id?: string
  file_key?: string,
  category?: string
  file?: File
  username?: string
  community_id?: string
  resource_id?: string
  timestamp?: string
  municipality?: string
  expiration?: string
  credential_number?: string
  is_valid?: boolean
}


export type CommunitySchema = {
  "timezone"?: string,
  "preference"?: PreferenceSchema,
  "bgPhoto"?: string,
  "address"?: string,
  "city"?: string,
  "equipments"?: string[],
  "foodPrograms"?: string[],
  "last_updated"?: string,
  "personel"?: string[],
  "id"?: string,
  "kitchen_stage"?: string,
  "description"?: string,
  "features"?: string,
  "logo"?: string,
  "dept"?: string,
  "admin_id"?: string,
  "requirements"?: RequirementSchema[],
  "state"?: string,
  "services"?: string,
  "active"?: boolean,
  "plans"?: PlanSchema[],
  "country"?: string,
  "location"?: string,
  "kitchen_type"?: string,
  "county"?: string,
  "website"?: string,
  "created"?: string,
  "zipcode"?: string,
  "name"?: string,
  "memberships"?: MembershipSchema[],
  "capacity"?: string
  "size"?: string
  "spaces"?: KitchenSpaceSchema[]
  "resource_count"?: number
  "membership_requests"?: MembershipSchema[]
  "min_resp_hrs"?: number
  "max_resp_hrs"?: number
}

export type SettingsOptionsType = {
  name: string
  description: string
  icon: any
  path: ResourceType
  tags: string[]
}


export type FilterType = {
  resourceType: ResourceType
  state: string
  active: boolean
  county?: string
  stage?: string
  sortBy?: SortByType
}

export type SearchFilterOptionType = {
  searchTerm: string
  currentFilter: FilterType
  signInModalIsOpen: boolean
  messagesOpen: boolean
  messageCommunityId?: string
  setMessagesOpen: React.Dispatch<React.SetStateAction<boolean>>
  setMessageCommunityId: React.Dispatch<React.SetStateAction<string | undefined>>
  changeSearchTerm: React.Dispatch<React.SetStateAction<string>>
  setCurrentFilter: React.Dispatch<React.SetStateAction<FilterType>>
  setSignInModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export interface TimeBlock {
  start: Moment;
  end: Moment;
} 


export interface TimeSlot {
  open_time: string;
  close_time: string;
  period_type: 'STANDARD' | 'PEAK' | 'OFF_PEAK'
}


export interface ResourceOptionType {
  [key: string]: TimeSlot[] | Array<CloseHoursType | ClosedDatesType | InventorySchema> | ResourceType | string[] | string | FloorPlanSchema | undefined;
  name: string;
  // type: ResourceType
  sun: TimeSlot[];
  mon: TimeSlot[];
  tue: TimeSlot[];
  wed: TimeSlot[];
  thu: TimeSlot[];
  fri: TimeSlot[];
  sat: TimeSlot[];
  // closed_hours?: Array<CloseHoursType>;
  closed_dates?: ClosedDatesType[];
  equipments?: Array<InventorySchema>;
  features?: string[];
  services?: string[];
  floor_plan?: FloorPlanSchema;
  last_updated?: string;
}

export interface ClosedTimeBlockType {
  end_time: string
  start_time: string
}

interface CloseHoursType extends ClosedTimeBlockType {
  date?: string
}

export interface ClosedDatesType { 
  dates: Date[]; 
  times: ClosedTimeBlockType[]; 
}

export type WeekdayOptionFields = 'sun' |'mon' |'tue' |'wed' |'thu' |'fri' |'sat' 

export type FloorPlanSchema = {
  length: number;
  width: number;
  area: number;
  perimeter: number;
  center: {
    x: number;
    y: number;
  };
  corners: {
    x: number;
    y: number;
  }[];
  walls: {
    x: number;
    y: number;
  }[];
  max_capacity: number;
  buffer_time: number;
}

export interface ResourceSchema {
  "requires_membership"?: boolean,
  "rules"?: string[],
  "timezone"?: string,
  "community_id"?: string
  // "preference"?: PreferenceSchema,
  "bgPhoto"?: string,
  "bgPhotos"?: string[],
  "address"?: string,
  "city"?: string,
  // "equipments"?: string[],
  // "foodPrograms"?: string[],
  "last_updated"?: string,
  // "personel"?: string[],
  "id"?: string,
  "resource_type"?: ResourceType,
  "description"?: string,
  // "features"?: string,
  "logo"?: string,
  // "dept"?: string,
  "admin_email"?: string,
  // "requirements"?: any[],
  "state"?: string,
  "services"?: any[],
  "active"?: boolean,
  // "plans"?: any[],
  "country"?: string,
  "location"?: string,
  // "kitchen_type"?: string,
  "county"?: string,
  "website"?: string,
  "created"?: string,
  "zipcode"?: string,
  "name"?: string,
  // "memberships"?: MembershipSchema[],
  // "capacity"?: number
  "size"?: string
  "rating"?: number
  "plans"?: ResourcePlanSchema[]
  "requirements"?: RequirementSchema[]
  "resource_options"?: ResourceOptionType;
  "fees"?: FeeSchema[]
  "discounts"?: DiscountSchema[]
  "start_time"?: string
  "end_time"?: string
  "total_amount"?: number
  "resource_subtype"?: string
  "resource_inventory"?: TrainingOrganizationSchema | ResourceInventorySchema
  // "spaces"?: KitchenSpaceSchema[]
  // "membership_requests"?: MembershipSchema[]
  // buffer_time?: number
}

export interface FeeSchema {
  id?: string
  name: string
  description?: string
  rate: number
  resource_id?: string
  community_id?: string
  created?: string
  last_updated?: string
}

export type DiscountType = 'percentage' | 'fixed'

export interface DiscountSchema extends FeeSchema {
  end_date?: string
  start_date?: string
  discount_type: DiscountType
}

export interface FeedPostSchema {
  created?: string;
  reply?: object;
  facets?: any[];
  last_updated?: string;
  embed?: object;
  created_at?: string;
  tags?: object;
  id?: string;
  entitities?: object;
  uri?: string;
  cid?: string;
  content: string;
  username?: string;
  labels?: object;
  langs?: string[];
  text?: string;
  resource_id?: string;
  py_type?: string;
  is_admin?: boolean;
  image?: string;
  resource_type: "kitchen" | "documentation" | "training" | "funding" | "expert" | "farm";
}

export interface SavedResourceSchema extends ResourceSchema {
  resource_id: string
}

export interface KitchenSpaceSchema {
  id: string;
  community_id: string;
  resource_options: ResourceOptionType;
  // ... other properties
}

export type PreferenceSchema = {
  "loginview"?: string,
  "size"?: string,
  "urgency"?: string,
  "equipments"?: string,
  "frequency"?: string,
  "zipcode"?: string,
  "usertype"?: string,
  "userneed"?: string,
  "budget"?: string,
  "username"?: string
}

export type BookingSchema = {
  // kitchen_id?: string,
  location?: string;
  notes?: string;
  type?: string;
  last_updated?: string;
  summary?: string;
  username?: string;
  start_time: string;
  end_time: string;
  has_reminder?: boolean;
  created?: string;
  community_id?: string;
  payment_method?: string;
  status?: string;
  plan_description?: string
  plan_name?: string
  plan_rate?: number
  plan_recurrence?: string
  booking_recurrence?: BookingRecurrenceType
  end_recurrence?: string
  recurrence_count?: number
  // equipments: [
  //   {
  //     id: string,
  //     name: string,
  //     price: number
  //   }
  // ],
  id?: string;
  description?: string;
  total_hours?: number;
  fees?: FeeSchema[];
  discounts?: DiscountSchema[];
  total_cost?: number;
  subtotal_cost?:number
  equipments?: string[];
  community_logo?: string
};

export type TeamMemberStatus = 'invited' | 'accepted' | 'rejected' | 'expired' | 'removed';

export interface TeamMemberSchema {
  id: string;
  first_name: string;
  last_name: string;
  username?: string;
  email: string;
  avatar?: string;
  role?: string;
  status?: TeamMemberStatus;
  created?: string;
  last_updated?: string;
}

export interface ResourceBookingSchema {
  id?: string;
  uid?: string;
  community_id?: string
  resource_id?: string;
  resource_name?: string
  resource_address?: string
  resource_city?: string
  resource_county?: string
  resource_state?: string
  resource_type?: ResourceType;
  username?: string;
  user_full_name?: string;
  user_avatar?: string;
  user_email?: string;
  business_id?: string;
  business_name?: string;
  business_type?: string;
  business_category?: string;
  location?: string;
  summary?: string;
  description?: string;
  notes?: string;
  status?: BookingStatusType
  start_time?: string;
  end_time?: string;
  has_reminder?: boolean;
  created?: string;
  last_updated?: string;
  payment_method?: string;
  plan_id?: string
  plan_description?: string
  plan_name?: string
  plan_rate?: number
  plan_recurrence?: string
  booking_recurrence?: BookingRecurrenceType
  end_recurrence?: string
  recurrence_count?: number
  total_hours?: number;
  fees?: FeeSchema[];
  discounts?: DiscountSchema[];
  total_cost?: number;
  subtotal_cost?:number
  equipments?: string[];
  resource_logo?: string
  resource_bgPhoto?: string
  order_inventory?: OrderItemSchema[] // pre order
  order_items?: OrderItemSchema[] // post order
  timezone?: string
  /** Team members included on this booking. */
  team_members?: TeamMemberSchema[]
  excludes_space?: boolean
}

export interface BookingCardProps {
  booking: BookingSchema;
}

export interface SchoolGridProps {
  sliced?: boolean;
  searchTerm?: {search: string, filter: string}
  changeSearchTerm: React.Dispatch<React.SetStateAction<{search: string, filter: string}>>
}

export interface CommunityGridProps {
  sliced?: boolean;
  searchTerm?: {search: string, filter: string}
  changeSearchTerm: React.Dispatch<React.SetStateAction<{search: string, filter: string}>>
}

export interface CommunityCardProps {
  community: CommunitySchema;
  allMemberships: MembershipSchema[]
}


export interface SavedResourceCardProps {
  resource: SavedResourceSchema;
  isMobile?: boolean
  handleRemoveSavedResource: (resourceId: string | undefined) => void
  // resourceIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  // allMemberships: MembershipSchema[]
}



export interface BookedResourceCardProps {
  booking: ResourceBookingSchema;
  isMobile?: boolean
  // handleRemoveSavedResource: (resourceId: string | undefined) => void
  // resourceIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  // allMemberships: MembershipSchema[]
}



export interface LoginProps {
  registerUser?: (user: AuthSchema) => boolean
  togglePhone?: () => void
  toggleEmail?: () => void
  toggleSignIn?: () => void
  toggleSignUp?: () => void
  loginType?: string,
  handleUpdateLoginType?: (loginType: string) => void
}

// export interface PhoneLoginProps {
//   registerUser : (user_to_register: object) => void
//   togglePhone: () => void
// }

export interface MessageSchema {
  id?: string
  community_id: string
  subject?: string
  read_status?: boolean,
  type?: 'sent' | 'received',
  content: string,
  username: string
  created: string
  last_updated?: string
}



//  ######  CustomLink  ######## //
export interface CustomLink {
  label: string;
  href: string;
  targetBlank?: boolean;
}

//  ##########  PostDataType ######## //
export interface TaxonomyType {
  id: string | number;
  name: string;
  href: string;
  count?: number;
  thumbnail?: string;
  desc?: string;
  color?: TwMainColor | string;
  taxonomy: "category" | "tag";
  listingType?: "stay" | "experiences" | "car";
}

export interface AuthorType {
  id: string | number;
  firstName: string;
  lastName: string;
  displayName: string;
  avatar: string;
  bgImage?: string;
  email?: string;
  count: number;
  desc: string;
  jobName: string;
  href: string;
  starRating?: number;
}

export interface PostDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  categories: TaxonomyType[];
  title: string;
  featuredImage: string;
  desc?: string;
  commentCount: number;
  viewdCount: number;
  readingTime: number;
  postType?: "standard" | "video" | "gallery" | "audio";
}

export type TwMainColor =
  | "pink"
  | "green"
  | "yellow"
  | "red"
  | "indigo"
  | "blue"
  | "purple"
  | "gray";

//
export interface StayDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  title: string;
  featuredImage: string;
  commentCount: number;
  viewCount: number;
  address: string;
  reviewStart: number;
  reviewCount: number;
  like: boolean;
  galleryImgs: string[];
  price: string;
  listingCategory: TaxonomyType;
  maxGuests: number;
  bedrooms: number;
  bathrooms: number;
  saleOff?: string | null;
  isAds: boolean | null;
  map: {
    lat: number;
    lng: number;
  };
}

//
export interface ExperiencesDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  title: string;
  featuredImage: string;
  commentCount: number;
  viewCount: number;
  address: string;
  reviewStart: number;
  reviewCount: number;
  like: boolean;
  galleryImgs: string[];
  price: string;
  listingCategory: TaxonomyType;
  maxGuests: number;
  saleOff?: string | null;
  isAds: boolean | null;
  map: {
    lat: number;
    lng: number;
  };
}

//
export interface CarDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  title: string;
  featuredImage: string;
  commentCount: number;
  viewCount: number;
  address: string;
  reviewStart: number;
  reviewCount: number;
  like: boolean;
  galleryImgs: string[];
  price: string;
  listingCategory: TaxonomyType;
  seats: number;
  gearshift: string;
  saleOff?: string | null;
  isAds: boolean | null;
  map: {
    lat: number;
    lng: number;
  };
}

export interface FocusGroupFormData {
    first_name: string;
    last_name: string;
    email: string;
    availability: string[];
    meeting_style: string;
    session_length: number;
    about: string;
    ideas: string;
    terms_accepted: boolean;
    last_updated?: string;
    created?: string;
    community_id?: string;
    username?: string;
    id?: string;
    status?: string;
}

export interface AvailabilityOption {
    value: 'weekday-morning' | 'weekday-afternoon' | 'weekday-evening' | 'weekend-morning' | 'weekend-afternoon' | 'weekend-evening';
    label: string;
}

export interface MeetingStyleOption {
    value: 'inPerson' | 'virtual' | 'hybrid';
    label: string;
}

export interface SessionLengthOption {
    value: number;
    label: string;
}


